/* eslint-disable */
import React, { Component } from 'react';
import { Redirect } from 'react-router';

import Fullscreen   from "react-full-screen";
import NextSong     from '../../components/NextSong/NextSong';
import Classes      from './PublicScreen.css';
import socket       from '../../SocketManager';
import Aux          from './../../hoc/Aux';
import Actions      from './../../components/Actions/Actions';
import OnlineSong   from './../../components/OnlineSong/OnlineSong';
import MConfig      from './../../moramma-config.json';
import logger       from './../../logger';
import axios        from 'axios';
import helpers from '../../helpers/helpers';
import lang from '../../lang.json';

class PublicScreen extends Component {

    state = {
        socket : {
            signature : 'nextsong-signature'
        },
        roomName: null,
        songs : [],
        actions : [],
        showblock : false,
        onlineSong: null,
        isFull: false,
        socketReconnection: false,
        logged : true,
        eventForTriggerMinSongTimerToOnlineSongComponent : false,
        language: 'IT-it'
    }

    fetchUserData = async () => {
        const localtoken = localStorage.getItem('API');
        if(!localtoken) {
            return this.setState({ logged: false });
        }

        await axios({
            method: 'post',
            url: `${MConfig['BASE_API']}/react/user`,
            headers: {
                "Authorization" : `Bearer ${localtoken}`,
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            data: { token: localtoken }
        }).then(async items => {
            this.setState({ roomName: items.data.data.location.name, userDefaultPlaylist: items.data.data.defaults.defaultPlaylist, userData: items.data.data.location })         
            this.setState({ language: items.data.data.owner.language });
        });
    }


    socketPing = () => {
        socket.emit('socket-ping-keep-alive');
        setTimeout(this.socketPing, 5000);
      }

      
    fetchActualSpotStatus = async () => {
        const localtoken = localStorage.getItem('API');
        if(!localtoken) {
            return this.setState({ logged: false });
        }
       // console.log('rrr', this.state.roomName);

        await axios({
            method: 'get',
            url: `${MConfig["BASE_API"]}/rooms/${this.state.roomName}/songs`,
            headers: {
                "Authorization" : `Bearer ${localtoken}`,
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }
          }).then(items => {
            this.onNewSongHandler(items.data.data);
          });  
    }

    startSocketEvents = () => {

        socket.on('connect', () => {
            // remove 'disconnected from server' banner
            this.setState({showblock : false});

            if(this.state.socketReconnection) {
                window.location.reload();
            }
        });    

        this.socketPing();

        // reset connection
        this.setState({showblock : false});

        logger.debug(`[NEXTSONG][componentDidMount() | connect] send signature '${this.state.socket.signature}'to server for validation`);
        socket.emit('react-subscribe-id', { customId: this.state.socket.signature, room: this.state.roomName});

        /** wait ack */
        // TODO: repace with jwt
        socket.on('server-ack-id-validation', () => {
            logger.debug('[NEXTSONG][componentDidMount() | server-ack-id-validation] receive ack validation from server');
        });

        /** DEPRECATED */
        socket.on('server-new-song', ( data ) => {                
            logger.debug('[NEXTSONG][componentDidMount() | server-new-song] receive new json');
           // console.log('ooo', data);
            this.onNewSongHandler(data);
        });

        
        /** SOCKET: [r-server-vote-song] */
        socket.on('r-server-vote-song', ( data ) => {
            logger.debug('[NEXTSONG][componentDidMount() | r-server-vote-song] receive new action');

            // call handler
            console.log('r-server-vote-song', data);
            
            this.onNewActionHandler(data);                
        });

        socket.on('r-server-song-go-online', ( data ) => {
            logger.debug('[NEXTSONG][componentDidMount() | r-server-song-go-online] receive new action and song');

            let action = data.action;
            let song = data.songs;

            console.log(song);

            console.log('r-server-song-go-online', data);
            this.onNewActionHandler(action);
            
            this.onNewSongHandler(song);

            this.setState({ eventForTriggerMinSongTimerToOnlineSongComponent: !this.state.eventForTriggerMinSongTimerToOnlineSongComponent });
        });

        socket.on('r-server-skip-action', ( payload ) => {
            logger.debug(`[NEXTSONG][componentDidMount() | r-server-skip-action] receive new skip action`+ JSON.stringify(payload));

            this.onNewActionHandler(payload);
        });

        /**
         * Received new song
         */
        socket.on('r-server-new-song', ( data ) => {
            console.log('SONGGG1');
            logger.debug(`[ManagerScreen|r-server-new-song] SOCKET.IO -server-new-song`);
            logger.debug(`[ManagerScreen|r-server-new-song] Received new song`);
            this.onNewSongVotedHandler(data);                
        });

        socket.on('connect_error',() => {
            this.setState({showblock : true});
            logger.error(`[ManagerScreen|connect_error] connect_error`);

            // restart connection
            socket.disconnect();
            socket.connect();
            this.setState({ socketReconnection: true });
         });  

         /**
          * Fired upon a connection timeout.
          */
         socket.on('connect_timeout', (timeout) => {
            this.setState({showblock : true});
            logger.error(`[ManagerScreen|connect_error] connect_timeout`);

            // restart connection
            socket.disconnect();
            socket.connect();
            this.setState({ socketReconnection: true });
         });
 
         /**
          * Fired when an error occurs.
          */
         socket.on('error', (error) => {
            this.setState({showblock : true});
            logger.error(`[ManagerScreen|connect_error] error`);

            // restart connection
            socket.disconnect();
            socket.connect();
            this.setState({ socketReconnection: true });
         });
 
         socket.on('disconnect', (reason) => {
            this.setState({showblock : true});
            logger.error(`[ManagerScreen|connect_error] disconnect`);

            // restart connection
            socket.disconnect();
            socket.connect();
            this.setState({ socketReconnection: true });
         });

         /**
          * Fired when couldn’t reconnect within reconnectionAttempts.
          */
         socket.on('reconnect_failed', () => {
            this.setState({showblock : true});
            logger.error(`[ManagerScreen|connect_error] reconnect_failed`);

            // restart connection
            socket.disconnect();
            socket.connect();
            this.setState({ socketReconnection: true });
         });

         socket.on('server-owner-data-updated', (payload) => {
            logger.debug('[ManagerScreen][componentDidMount() | server-owner-data-updated] receive new userdata changes', payload);
    
            let oldLang = this.state.language;
            oldLang = payload.owner.language;
            this.setState({ language: oldLang });
          });

          /**
         * All songs has been deleted, refresh it
         */
        socket.on('server-delete-all-songs', (data) => {
            logger.debug('[ManagerScreen|server-delete-all-songs] Called');
            console.log(data);
            this.onSongsDeleted(data);                
        });

        /**
         * song is deleted
         */
        socket.on('r-server-delete-song', (data) => {
            logger.debug('[ManagerScreen|r-server-delete-song] Called');
            this.onSongDeletedSetState(data.song);     
            // this.onNewActionHandler(data);           
        });
    }

    onSongsDeleted = (data) => {
        let oldSongs = this.state.songs;
        oldSongs = oldSongs.filter((el) => el.type === 'onlineSong');
  
        this.setState({ songs: oldSongs });
      }

      onSongDeletedSetState = (song) => {
          console.log(song.id);
        let oldSongs = this.state.songs;
        oldSongs = oldSongs.filter((el) => el.id !== song.id);
  
        this.setState({ songs: oldSongs });
      }

    goFull = () => {
        this.setState({ isFull: true });
    }

    async componentDidMount() {
        await this.fetchUserData();
        await this.startSocketEvents();
        await this.fetchActualSpotStatus();
    }


    /** Compare function to order publiscreen list */
    compare = ( a, b ) => {
        const votesB = b.votes; 
        const votesA = a.votes;

        if (votesB < votesA) {
            return -1;
        }
        if (votesB > votesA) {
            return 1;
        }

        const insTimeA = a.insertionTime.toUpperCase();
        const insTimeB = b.insertionTime.toUpperCase();
        if (insTimeA < insTimeB) {
            return -1;
        }
        if (insTimeA > insTimeB) {
            return 1;
        }
        
        // names must be equal
        return 0;
    }


    onSongReproducingHandler = ( song ) => {};

    /** Handler: new action received */
    onNewActionHandler = (data) => {
        let oldactions = this.state.actions;

        oldactions = [data].concat(oldactions);

        if(oldactions.length >= 7) {
            oldactions.pop();
        }

        this.setState({actions : oldactions});
    };

    /** Handler: new song voted */
    onNewSongVotedHandler = (data) => {
        let oldSongs = this.state.songs;

        // search song inside this.state
        const found = oldSongs.findIndex( el => { 
            return el._id === data._id;
        });

        if (found < 0) {
            // if song is new, add
            oldSongs = oldSongs.concat(data);
        }
        else {
            // replace with new data
            oldSongs.splice(found, 1);
            oldSongs = oldSongs.concat(data);
        }

        oldSongs.sort(this.compare);

        // set state
        this.setState({songs : oldSongs});
    };

    /** Handler: new song proposed */
    onNewSongHandler = (data) => {
        if(Array.isArray(data)) {
            data.forEach((el) => {
                if (el.type === 'songVoted') {
                  let oldSongs = this.state.songs;
                  const index = oldSongs.findIndex(x => x.id === el.id);
                  if (index === -1) {
                    // adding song
                    oldSongs = oldSongs.concat(el);
                  } else {
                    // replace with new data
                    oldSongs.splice(index, 1);
                    oldSongs = oldSongs.concat(el);
                  }  
        
                  oldSongs.sort(helpers.compare);
                  this.setState({ songs: oldSongs });
                }
                else if(el.type === 'onAir') {
                    let oldSongs = this.state.songs;
                    const index = oldSongs.findIndex(x => x.id === el.id);

                    if(index !== -1) {
                        oldSongs.splice(index, 1);
                    }
                    // 
                    this.setState({onlineSong : el, songs : oldSongs});
                }
              });
        } else {
            if(data.type === 'songVoted'){
                const oldSongs = this.state.songs;
                const newSongs = oldSongs.concat(data)
            
                newSongs.sort(this.compare);
                this.setState({songs : newSongs});
            }  
            if(data.type === 'onAir') {
                const oldSongs = this.state.songs;
                oldSongs.shift(); 
                this.setState({onlineSong : data, songs : oldSongs});
            }
        } 
    }

    render() {
        if(this.state.logged === false) {
             return <Redirect to='/' />
        }
        
        return(
            <Aux>
                <Fullscreen
                    enabled={this.state.isFull}
                    onChange={isFull => this.setState({isFull})}
                    >
                {
                    this.state.showblock === true ? 
                            <div className={[Classes.BgAlert, Classes.TxtCenter].join(' ')}>
                                <br/>
                                <p>Warning: No server connection available.</p>
                                <br/>
                            </div>  
                        : 
                            null
                }
                
                <div className={Classes.BgOrange}>
                    
                <img onClick={this.goFull} className={Classes.FullSc} src={require('../../assets/svg/full-size.svg')} alt='test'/>
                    <div className="container">
                        <OnlineSong
                            song={this.state.onlineSong}
                            actions={this.state.actions}
                            songs={this.state.songs} 
                            startTimer={this.state.eventForTriggerMinSongTimerToOnlineSongComponent}
                            language={this.state.language}
                            roomName={this.state.roomName}
                        />
                    </div> 
                </div>
             <br/>
                <div className="container"> 

                    <div className='row'>
                        <div className='col-7'>
                            <NextSong
                                songs={this.state.songs} 
                                upcomingTitle={lang[this.state.language].upcoming_songs}
                            />
                        </div>
                        <div className='col-5'>
                            <Actions                        
                                events={this.state.actions}
                                eventTitle={lang[this.state.language].events_title}
                                language={this.state.language}
                            />
                        </div>
                    </div>
                </div>
                </Fullscreen>
            </Aux>   
        );
    };
}

export default PublicScreen;